// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"114":"000942e3","152":"000942e3","219":"97516ab6","318":"97516ab6","591":"ca700767","686":"ca700767","865":"ca700767","961":"97516ab6"}[chunkId] + ".chunk.css";
};